export function ViewAllHintsShortcutsColumnSeparator() {
  return <div className="w-px bg-bar-border" />;
}
